var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper},[_c('div',{class:_vm.$style.speeds},_vm._l((_vm.speeds),function(speed,key){return _c('div',{key:("speed" + key),class:_vm.$style.speed},[_c('div',[_vm._v(_vm._s(speed)+" km/h")])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }